import typePolicies from '#admin/typePolicies.js';
import UploadHttpLink from '#app/apollo/upload/UploadHttpLink.js';
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';

let client: ApolloClient;

declare global {
  interface Window {
    __apolloCache: any;
  }
}

export function getApolloClient() {
  if (client) {
    return client;
  }

  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? null;

  const cache = new InMemoryCache({
    typePolicies,
  });
  if (window.__apolloCache) {
    cache.restore(window.__apolloCache);
  }

  const httpLink = new UploadHttpLink({
    uri: '/graphql',
    headers: {
      'CSRF-Token': csrfToken ?? '',
    },
  });

  const link = ApolloLink.from([httpLink]);
  client = new ApolloClient({
    cache,
    link,
    ssrForceFetchDelay: 1000,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });

  return client;
}
